export default __webpack_public_path__ + "static/media/4.bf395ca2.svg";